module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_c('div', [_c('strong', [_vm._v("Monday:")]), _vm._v(" " + _vm._s(_vm.format(_vm.hours["mon"])))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Tuesday:")]), _vm._v(" " + _vm._s(_vm.format(_vm.hours["tues"])))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Wednesday:")]), _vm._v(" " + _vm._s(_vm.format(_vm.hours["wed"])))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Thursday:")]), _vm._v(" " + _vm._s(_vm.format(_vm.hours["thurs"])))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Friday:")]), _vm._v(" " + _vm._s(_vm.format(_vm.hours["fri"])))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Saturday:")]), _vm._v(" " + _vm._s(_vm.format(_vm.hours["sat"])))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Sunday:")]), _vm._v(" " + _vm._s(_vm.format(_vm.hours["sun"])))])]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-3",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.edit = true
      }
    }
  }, [_vm._v("\n      Edit\n    ")])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "400",
      "scrollable": ""
    },
    model: {
      value: (_vm.edit),
      callback: function($$v) {
        _vm.edit = $$v
      },
      expression: "edit"
    }
  }, [(_vm.edit) ? _c('operating-hours', {
    attrs: {
      "autosave": _vm.edit
    },
    on: {
      "close": function($event) {
        _vm.edit = false
      }
    },
    model: {
      value: (_vm.hours),
      callback: function($$v) {
        _vm.hours = $$v
      },
      expression: "hours"
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45bcfd96","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/settings/locations/OperatingHoursView.vue
// module id = 1411
// module chunks = 9